import React, { useEffect, useMemo, useCallback } from 'react';
import { ReactFlow, useNodesState, useEdgesState, useReactFlow } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import './style.scss';
import customEdge from './customEdge';
import CardNode from './nodes/CardNode';
import DotNode from './nodes/DotNode';
import { createInitialNodes } from './utils/flowNodes';
import { createInitialEdges } from './utils/flowEdges';
import { isWeb } from '../../../utils/utility';

const edgeTypes = { customEdge };
const nodeTypes = { card: CardNode, dot: DotNode };

const AirHvacFlowDiagram = ({ airDevices = [], hvacs = [], onDeleteHvac, fromManageHVACSystem }) => {
  const { fitView } = useReactFlow();

  const nodesData = useMemo(
    () => createInitialNodes(airDevices, hvacs, onDeleteHvac, fromManageHVACSystem),
    [airDevices, hvacs, onDeleteHvac]
  );

  const edgesData = useMemo(
    () => createInitialEdges(airDevices, hvacs),
    [airDevices, hvacs]
  );

  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);

  useEffect(() => {
    setNodes(nodesData);
    setEdges(edgesData);

    setTimeout(() => {
      fitView({ padding: 0.2 });
    }, 0);

  }, [nodesData, edgesData, setNodes, setEdges, fitView]);

  const handleOverlayClick = useCallback((e) => {
    const overlay = e.currentTarget;
    overlay.style.pointerEvents = 'none';
    const el = document.elementFromPoint(e.clientX, e.clientY);
    overlay.style.pointerEvents = '';
    const deleteContainer = el?.closest('.delete-hvac-container');
    if (deleteContainer) {
      deleteContainer.click();
    }
  }, []);

  const unlinkedHvacsCount = hvacs.filter(hv => !hv['linked-air-devices']?.length).length;
  const heightRows = airDevices.length + unlinkedHvacsCount;
  const wrapperHeight = `${heightRows * (isWeb() ? 140 :  75)}px`;

  return (
    <div className="xyflow-wrapper" style={{ height: wrapperHeight, position: 'relative' }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        edgeTypes={edgeTypes}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        fitView
        panOnDrag={false}
        zoomOnScroll={false}
        zoomOnDoubleClick={false}
        panOnScroll={false}
        zoomOnPinch={false}
        autoPanOnConnect={false}
        nodesConnectable={false}
        nodeExtent={[[0, 0], [550, 800]]}
      />
      <div className="xyflow-touch-overlay" onClick={handleOverlayClick} />
    </div>
  );
};

export default AirHvacFlowDiagram;
